export { SkeletonModalBody } from './SkeletonModalBody'
